import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getCentersRows = store => store[NAME].rows;